module.exports = __webpack_public_path__ + "img/icons8-audi.11aa61d3.svg";